/*
 * @Author: jyy 
 * @Date: 2024-12-23 16:28:15 
 * @Last Modified by: jyy
 * @Last Modified time: 2025-01-14 18:36:44
 */

<template>
    <div>
        <div :style="{ paddingTop: !isIos && isNative ? '44px' : '' }"></div>
        <div class="nav-bar" :class="{'nav-bar-ios':isIos}">
            <img class="nav-bar-left" src="@/assets/list/searchBackIcon.png" @click="goBack" alt="">
            <div class="nav-bar-title">{{ this.title }}</div>
        </div>
    </div>
</template>

<script>
import env from "@/utils/env";
export default {
    components: {},
    props: {
        title: {
            type: String,
            default: ""
        },
    },
    data() {
        return {};
    },
    watch: {},
    computed: {
        isIos() {
            return env.os == "ios"
        },
        isNative() {
            return env.isNative;
        }
    },
    created() { },
    mounted() { },
    methods: {
        goBack() {
            if (!["sinopec", "wxapp-hbgj", 'cnpc'].includes(env.hlsource)) {
                this.$page.back();
            } else {
                return false;
            }
        },
    }
}
</script>

<style lang='scss' scoped>
@import '@/scss/_vars.scss';
.nav-bar {
    width: 375 * $px;
    height: 44 * $px;
    padding-top: 6 * $px;
    padding-bottom: 6 * $px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 260;
    .nav-bar-left {
        width: 10 * $px;
        height: 18 * $px;
        position: absolute;
        left: 16 * $px;
    }

    .nav-bar-title {
        font-size: 16 * $px;
        color: #101010;
        font-weight: 500;
    }
}

.nav-bar-ios {
    height: calc(44px + constant(safe-area-inset-top));
    height: calc(44px + env(safe-area-inset-top));
    padding-top: calc(6px + constant(safe-area-inset-top));
    padding-top: calc(6px + env(safe-area-inset-top));
}
</style>